import React from "react";
import moment from "moment";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {setRedirectPath} from "../../modules/actions/authActions";
import {addToCart, getCart} from "../../modules/actions/cartActions";
import {addFlashMessage} from "../../modules/actions/flashMessages.js";
import "react-datepicker/dist/react-datepicker.css";
import {withRouter} from "react-router-dom";
import qs from "qs";
import {format} from "../../modules/utils";
import { getRechargeSimProducts, validateActiveSim, getSimDetails} from "../../modules/actions/productActions";

class RechargeSimController extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            startDate: moment(),
            useType: "GLOBAL",
            receiveType: "DELIVERY",
            returnType: "Mail",
            shippingFee: 0,
            quantity: 1,
            product : {},
            phone_no : ""
        };
    }

    isActivated(activeLineObject){

        if (typeof activeLineObject.status !== "undefined" || activeLineObject == null) {
            console.log("I am checking");
            let expirationDate  = moment();
            let status = activeLineObject.status.toLowerCase();
            if (status === "active"){
                console.log("statusActivated", status);
                this.setSimExpirationDate();
                this.setState({
                    startDate : expirationDate,
                    numberValidated : true
                });

            }else{
                console.log("notFound", status);
                this.setState({
                    numberValidated : false
                })
            }
        }else{
            console.log("notFound not activated");
            this.setState({
                numberValidated : false
            })
        }
    }

    validatePhoneNumber = () => {
        let { phone_no } = this.state;
        let payload = {
            phone_no : phone_no
        };
        this.props.validateActiveSim(payload).then(
            res => {
                if (res.status){
                    this.isActivated(res.activeLine);
                }
            },
            err => {
                console.log("Request has error : ", err.error)
            }
        );
    };

    onStartDateChange = date => {
        this.setState({
            startDate : date
        });
    };

    getSubscriptionEndDate(date, period, unit = 'days'){
        return moment(date).add(period - 1 ,unit);
    }

    setStartDate(date){
        console.log("ExpirationDate out Block", date);
        this.setState({
            startDate : date
        });
        console.log("stateExpirationDate", format(this.state.startDate));
    }

    setSimExpirationDate(){
        this.props.getSimDetails(this.state.phone_no).then(
            res => {
                if (res.status){
                    if(typeof res.sim !== "undefined" && typeof res.sim.expirationDate !== "undefined" && res.sim.expirationDate !== ""){
                        console.log("simObject",res.sim);
                        console.log("Sim Expiration Date",res.sim.expirationDate);
                        let date = moment(res.sim.expirationDate, "MM/DD/YYYY");

                        let difference = date.diff(moment(),"days");

                        console.log("dateDiff", difference);
                        if (difference >= 0){
                            console.log("dateAccepted");
                            this.setStartDate(date);
                        }
                    }
                }
            },
            err => {
                console.log("Request has error : ", err.error)
            }
        );
    }

    showMessage(message){
        this.refs.notify.notificationAlert({
            place: "bl",
            message: (
                <div>
                    <div>
                        <b>{message}</b>
                    </div>
                </div>
            ),
            type: "danger",
            icon: "now-ui-icons ui-1_bell-53",
            autoDismiss: 7
        });
    };

    addToCart = () => {
        const { product, useType, receiveType, returnType, shippingFee, quantity, phone_no } = this.state;
        const sessionId = localStorage.getItem("sessionId");
        const productId = product._id;
        const subtotal = product.globalPrice;
        const total = product.globalPrice;
        const startDate = format(this.state.startDate);

        const endDate = format(this.getSubscriptionEndDate(startDate,product.recurringPeriod));

        let payload = {
            startDate,
            endDate,
            useType,
            receiveType,
            returnType,
            quantity,
            sessionId,
            total,
            subtotal,
            shippingFee,
            productId,
            product,
            phone_no,
            cartType: "recharge"
        };

        this.performCartAction(payload);
    };

    performCartAction(payload){
        const { auth } = this.props;
        if (auth.isAuthenticated) {
            this.props
                .addToCart(payload)
                .then(data => {
                    console.log(data);
                    if (data.status) {
                        this.context.router.history.push({
                            pathname: "/checkout",
                            params : {
                                product: this.state.product,
                                checkoutType : "recharge"
                            }
                        });
                    } else {
                        this.showMessage(data.message);
                    }
                })
                .catch(error => {
                    this.showMessage(error.response.data.message);
                });
        } else {
            this.props.setRedirectPath("/checkout", payload);
            this.context.router.history.push({
                pathname : "/login",
                params : {
                        product : payload.product,
                        cart : payload,
                        checkoutType : "recharge"
                }
            });
        }
    }

    _onProductSelect = event => {
        const value = event.target.value;
        this.setProduct(this.getProductById(value));
    };

    getProductById(id){
        return this.state.products.find((product) => {
            return id === product._id
        });
    }

    componentDidMount() {

        this.props.getRechargeSimProducts();

        console.log("initialProps",this.props);
        if (typeof this.props.location.state !== 'undefined' && typeof this.props.location.state.product !== 'undefined'){
            this.setProduct(this.props.location.state.product);
        }
        else if(this.getQueryParams() && typeof this.props.auth.redirectPayload.product !== 'undefined'){
            const payload = this.props.auth.redirectPayload;
            console.log("redirectPayload=", payload);
            this.setProduct(payload.product);
            this.performCartAction(payload);
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        console.log("newProps: ", nextProps);
        if (typeof nextProps.products !== "undefined"){
            this.setState({
                products : nextProps.products
            })
            if(nextProps.products.length > 0) {
                this.setProduct(nextProps.products[0]);
            }
        }
    }

    setProduct(payload){
        console.log("selectedProduct", payload);
        this.setState({
            product :  {...payload}
        });
    }

    _onChange = event => {
        const field = event.target.name;
        const value = event.target.value;
        this.setState({ [field]: value });
    };
    getQueryParams(){
        const qsParsed = qs.parse(
            this.context.router.history.location.search.slice(1)
        );
        return !!qsParsed.login;
    }

    render() {
        const { product } = this.state;
        return(
                    <section className="BodyContainer">
                        <div className="container">
                            <div className="row position-relative">
                                <div className="col-lg-4 services_img_bg">
                                  <img src="/images/121918-001.jpg"/>
                                </div>

                                <div className="col-lg-8 sim_services_clip">
                                    <div className="services_bg_pad">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="text-left services_boxes mt-3 rounded p-4">

                                                    <div className="services_content mt-3">
                                                    <h5 className="SansSerif">T-Mobile Prepaid SIM Card Unlimited Talk, Text, and Data.</h5>
                                                    <h3 className="m-Title SansSerif bold700">Recharge</h3>

                                                    <div style={{ clear: "both", height: "20px" }} />

                                                    <div className="center-position">
                                                        <div className="form-group text-left">
                                                            <strong>US Phone Number</strong>
                                                        </div>
                                                        <div className="form-group text-left">
                                                            <input id="phone-number" className="form-control phone-number-field" name="phone_no" type="text" onChange={this._onChange}/>
                                                        </div>
                                                        <a href="javascript:void(0)" className="btn-white btn" onClick={this.validatePhoneNumber}>Verify Number</a>
                                                    </div>

                                                        {
                                                            (typeof this.state.numberValidated !== "undefined" && !this.state.numberValidated) ? (
                                                                <div className="error-text center-position">
                                                                    Your phone number is not verified. Please try again
                                                                </div>
                                                            ) : null
                                                        }


                                                        { (typeof this.state.numberValidated !== "undefined" && this.state.numberValidated) ? (

                                                            <div>
                                                                <div className="success center-position">
                                                                    <p>Congratulations! Your phone number is verified.</p>
                                                                </div>

                                                                <div style={{clear: 'both', height: '10px'}}></div>

                                                            { (this.state.products) ? (
                                                                <div className="recharge-products-wrapper">
                                                                <div className="center-position">
                                                                <p>Please Select a plan.</p>
                                                                </div>


                                                                <div className="center-position">
                                                                <select name="product" className="product-dropdown" id="product" onChange={this._onProductSelect}>
                                                                {this.state.products.map(
                                                                    (product) => (
                                                                        <option value={product._id}>{product.name} - ${product.globalPrice}</option>
                                                                    )
                                                                )}

                                                                </select>
                                                                </div>

                                                                <a href="javascript:void(0)" className="btn btn-outline-white margin-top-35" onClick={this.addToCart}>Continue</a>
                                                                <p className="mb-0 mt-2">
                                                                <h1>&nbsp;</h1>
                                                                </p>
                                                                </div>
                                                                ) : null }
                                                            </div>
                                                            ) : null }


                                                        {
                                                            (typeof this.state.numberValidated !== "undefined" && !this.state.numberValidated) ? (
                                                                <div style={{clear: 'both', height:"230px"}}>
                                                                </div>
                                                            ) : null
                                                        }

                                                        {
                                                            (typeof this.state.numberValidated === "undefined") ? (
                                                                <div style={{clear: 'both', height:"250px"}}>
                                                                </div>
                                                                    ) : null
                                                        }


                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
        );
    }
}


RechargeSimController.contextTypes = {
    router: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    return {
        auth: state.auth,
        cart: state.cart,
        products: state.product.products,
    };
}

export default withRouter(connect(
    mapStateToProps,
    { getRechargeSimProducts, getSimDetails, validateActiveSim, addToCart, addFlashMessage, setRedirectPath, getCart }
)(RechargeSimController));



// WEBPACK FOOTER //
// ./src/pages/rechargeSim/RechargeSim.js